import { render, staticRenderFns } from "./CustomerActivityLog.vue?vue&type=template&id=67cc421b&scoped=true"
import script from "./CustomerActivityLog.vue?vue&type=script&lang=js"
export * from "./CustomerActivityLog.vue?vue&type=script&lang=js"
import style0 from "./CustomerActivityLog.vue?vue&type=style&index=0&id=67cc421b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cc421b",
  null
  
)

export default component.exports